{
  "version": 1,
  "asset_id": "4f369a27-b270-4af2-9a63-af2f0f9ef420",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/4f369a27-b270-4af2-9a63-af2f0f9ef420/wordmark-600.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/4f369a27-b270-4af2-9a63-af2f0f9ef420/wordmark-600.webp",
  "original_filename": "wordmark-600.webp",
  "size": 27618,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:19:19Z"
}
